module.exports = __webpack_public_path__ + "img/USZ.da4eb46a.svg";